import { useFinanceiroCondicao } from "./use-financeiro-condicao";
import { FinanceiroCondicaoView } from "./view-financeiro-condicao";
import type { FinanceiroCondicaoProps } from "./types-financeiro-condicao";

export function FinanceiroCondicao(props: FinanceiroCondicaoProps) {
  const vm = useFinanceiroCondicao(props);
  return <FinanceiroCondicaoView {...vm} />;
}

export type * from "./types-financeiro-condicao";
